'use client';

import { NotFoundContent } from '@/components/NotFoundContent';

/**
 * Tenant (storefront) not-found — no locale context, uses Arabic default.
 */
export default function NotFound() {
    return (
        <NotFoundContent
            title="يبدو أننا فقدنا الخريطة!"
            description="الصفحة التي تبحث عنها غير موجودة أو تم نقلها. لكن لا تقلق، إيكو بوي هنا لإرشادك للعودة."
            backHomeLabel="العودة للرئيسية"
            goBackLabel="الرجوع للسابق"
            homeHref="/ar"
            isRTL={true}
        />
    );
}
